import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Col, UiDivider, UiListItem, UiQuestionnaireLayout, UiText, UiUnorderedList} from '~/components/elements';
import BoldText from '~/components/shared/BoldText';
import {PAGE_URLS} from '~/constants';
import {WEIGHT_LOSS_KEYS, WEIGHT_LOSS_ONE_QUESTIONNAIRES} from '~/constants/medical-questionnaires';
import {setNextQuestionnaire, setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {submitOrLogMdq} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';

interface Props {}

const Questionnaire8CGMScreen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const {methodKey, medicalUUID, answerOrder} = mdq;
  //   const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  //   const {wpAuthUser} = medicalQuestionnaire;

  //   const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = WEIGHT_LOSS_ONE_QUESTIONNAIRES.find(i => i.key === WEIGHT_LOSS_KEYS.COULD_WORK_FOR_YOU_CGM);

  const collectedData = mdq.collectedData;

  const onClickSubmit = () => {
    const answerData = {
      key: WEIGHT_LOSS_KEYS.COULD_WORK_FOR_YOU_CGM,
      index: questionnaire?.index || '',
      data: {},
      order: answerOrder + 1,
    };

    dispatch(setQuestionnaireAnswer(answerData));
    dispatch(
      submitOrLogMdq({
        data: {
          uid: medicalUUID,
          methodKey: methodKey.toLowerCase(),
          status: 'draft',
          data: {
            ...collectedData,
            [WEIGHT_LOSS_KEYS.COULD_WORK_FOR_YOU_CGM]: answerData,
          },
        },
      }),
    );
    // dispatch(setNextQuestionnaire({value: WEIGHT_LOSS_KEYS.ELEVATE_PROGRAM_GOALS}));
    history.push(PAGE_URLS.MDQ1_CHART);
  };

  return (
    <UiQuestionnaireLayout
      actions={questionnaire?.actions}
      checkoutStep={questionnaire?.checkoutStep}
      handleOnNext={onClickSubmit}
      pageTitle={questionnaire?.title}
    >
      <Col alignItems="center" textAlign="center" mt={12} px={2}>
        <UiText fontSize="xl" fontWeight="bold" mb={7}>
          {questionnaire?.questions?.default}
        </UiText>
        <UiText maxW={80} fontSize="sm" mb={14}>
          {questionnaire?.questions?.description}
        </UiText>
        <UiDivider maxW={80} mb={10} />
        <Col textAlign="left" px={6} mt={1}>
          <UiText mb={2.5} fontWeight={500}>
            {questionnaire?.descriptions?.sub}
          </UiText>
          <UiUnorderedList textAlign="left">
            {questionnaire?.descriptions?.default?.map(desc => (
              <UiListItem key={desc} mb={2.5}>
                <BoldText text={desc} fontSize="xs" />
              </UiListItem>
            ))}
          </UiUnorderedList>
        </Col>
        <Col textAlign="left" px={6} mt={4}>
          <UiText mb={2.5} fontWeight={500}>
            {questionnaire?.optional?.title}
          </UiText>
          <UiUnorderedList textAlign="left">
            {questionnaire?.optional?.description?.map(desc => (
              <UiListItem key={desc} mb={2.5}>
                <BoldText text={desc} fontSize="xs" />
              </UiListItem>
            ))}
          </UiUnorderedList>
        </Col>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire8CGMScreen;
